import { IBudget } from '../../../../models/budgetV2';

// Only versions that were superseded show what changed in them; the latest one has no adjustments yet.
export const isPreviousVersion = (budget: IBudget | null | undefined): boolean => {
  const viewed = budget?.versionData?.versionNumber;
  const last = budget?.lastVersionNumber;
  return viewed !== undefined && last !== undefined && viewed < last;
};
